<template>
  <div>
    <div
      v-for="product of products"
      :key="product"
    >
      {{ product }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    products: {
      default: () => [],
      type: Array,
    },
  },
  computed: {
    productsSorted() {
      const products = this.product
      return products.sort((a, b) => (a).localeCompare(b))
    },
  },
}
</script>
